// @flow

import React, { Component } from "react";

import type { TaskType } from "../../data/tasks";
import type { Template } from "../../templates/";

import Block from "../Block/Block";
import PDF from "../PDF/PDF";
import Scratchpad from "../Scratchpad/Scratchpad";
import Wikipedia from "../Wikipedia/Wikipedia";
import TaskResponseForm from "../TaskResponseForm/TaskResponseForm";
import PostResponseModal from "./PostResponseModal";

import "./ElicitationScreen.css";
import Google from "../Google/Google";

type Props = {
  task: TaskType,
  template: Template,
  submit: (data: { confidence: number }) => void,
  lostFocus: () => void,
  modalVisible: boolean,
  closeModal: () => void,
  search: string => void,
  secondsRemaining: number,
  azureToken: string
};

type State = {
  modalVisible: boolean
};

class ElicitationScreen extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { modalVisible: props.modalVisible };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.modalVisible !== this.props.modalVisible) {
      this.setState({ modalVisible: nextProps.modalVisible });
    }
  }

  render() {
    const task = this.props.task;
    const template = this.props.template;
    const question = template.task.renderQuestion(task);
    return (
      <div className="ElicitationScreen">
        <PostResponseModal
          visible={this.state.modalVisible}
          onClose={this.props.closeModal}
          secondsRemaining={this.props.secondsRemaining}
        />
        <Block className="ElicitationScreen-Question">{question}</Block>
        <Block className="ElicitationScreen-Respond">
          <TaskResponseForm
            template={template}
            submit={this.props.submit}
            lostFocus={this.props.lostFocus}
          />
        </Block>
        <Block className="ElicitationScreen-Tools">
          {template.task.tools.pdf &&
            this.props.azureToken && (
              <PDF
                width="100%"
                height="1200px"
                url={
                  task.metadata.internal_pdf_link + "?" + this.props.azureToken
                }
              />
            )}
          {template.task.tools.scratchpad && <Scratchpad />}
          {template.task.tools.google && <Google search={this.props.search} />}
          {template.task.tools.wikipedia && <Wikipedia />}
        </Block>
      </div>
    );
  }
}

export default ElicitationScreen;



// WEBPACK FOOTER //
// ./src/components/Task/ElicitationScreen.js